import type { FilterState } from '../FilterDrawer';

export type CascadeLevel =
  | 'region'
  | 'depot'
  | 'department'
  | 'jobRole'
  | 'ageRange'
  | 'sex'
  | 'shiftPattern'
  | 'searchUser';

// For each level, the levels that must be reset to empty when it changes.
// Siblings age/sex/shift do NOT clear each other; all of them clear searchUser.
const DOWNSTREAM: Record<CascadeLevel, CascadeLevel[]> = {
  region: ['depot', 'department', 'jobRole', 'ageRange', 'sex', 'shiftPattern', 'searchUser'],
  depot: ['department', 'jobRole', 'ageRange', 'sex', 'shiftPattern', 'searchUser'],
  department: ['jobRole', 'ageRange', 'sex', 'shiftPattern', 'searchUser'],
  jobRole: ['ageRange', 'sex', 'shiftPattern', 'searchUser'],
  ageRange: ['searchUser'],
  sex: ['searchUser'],
  shiftPattern: ['searchUser'],
  searchUser: [],
};

/** Set `changed` to `values` and clear every downstream level. Returns a new object. */
export const clearDownstream = (filters: FilterState, changed: CascadeLevel, values: string[]): FilterState => {
  const next: FilterState = { ...filters, [changed]: values };
  for (const level of DOWNSTREAM[changed]) {
    next[level] = [];
  }
  return next;
};

/** Upstream id groups each select needs, derived from the current filter state. */
export const upstreamFor = (filters: FilterState) => ({
  depot: { regionIds: filters.region },
  department: { regionIds: filters.region, depotIds: filters.depot },
  jobRole: { regionIds: filters.region, depotIds: filters.depot, departmentIds: filters.department },
  ageSexShift: {
    regionIds: filters.region,
    depotIds: filters.depot,
    departmentIds: filters.department,
    jobRoleIds: filters.jobRole,
  },
  user: {
    regionIds: filters.region,
    depotIds: filters.depot,
    departmentIds: filters.department,
    jobRoleIds: filters.jobRole,
    ageRanges: filters.ageRange,
    sex: filters.sex,
    shiftPatterns: filters.shiftPattern,
  },
});
